const APP_TYPE = process.env.REACT_APP_TYPE

export const IS_BE_FIT = APP_TYPE === 'BE_FIT'

export const BRAND_NAME = IS_BE_FIT ? 'BeFit' : 'World Class'

const worldClassBrand = {
  50: '#FFF4E5',
  100: '#FFE0B8',
  200: '#FFCD8A',
  300: '#FFB95C',
  400: '#FFA52E',
  500: '#FF9200',
  600: '#CC7500',
  700: '#995700',
  800: '#663A00',
  900: '#331D00'
}

const worldClassAccent = {
  50: '#FFF5F5',
  100: '#FED7D7',
  200: '#FEB2B2',
  300: '#FC8181',
  400: '#F56565',
  500: '#E53E3E',
  600: '#C53030',
  700: '#9B2C2C',
  800: '#822727',
  900: '#63171B'
}

const beFitBrand = {
  50: '#F0FFE0',
  100: '#DCFFB3',
  200: '#C2FF80',
  300: '#A8FF4D',
  400: '#99FF26',
  500: '#8AFF00',
  600: '#6FCC00',
  700: '#539900',
  800: '#386600',
  900: '#1C3300'
}

const beFitAccent = {
  50: '#F0FFE0',
  100: '#C2FF80',
  200: '#99FF26',
  300: '#8AFF00',
  400: '#6FCC00',
  500: '#539900',
  600: '#3F7300',
  700: '#2D5400',
  800: '#1C3300',
  900: '#0D1A00'
}

export const BRAND_PALETTE = IS_BE_FIT ? beFitBrand : worldClassBrand
export const ACCENT_PALETTE = IS_BE_FIT ? beFitAccent : worldClassAccent
